import React from 'react';
import sum from 'lodash/sum';
var useColumnSizes = function (displayColumnsDefinitions, storeColumnsWidth, storeColumnsWidthVariant, setColumnWidth, columnLayout, minColumnWidth) {
    /**
     * decorate grid resize with layout and reset grid widths if layout changes
     */
    if (minColumnWidth === void 0) { minColumnWidth = 50; }
    var handleSetColumnWidth = React.useCallback(function (columnWidth) { return setColumnWidth(columnWidth, columnLayout); }, [columnLayout, setColumnWidth]);
    React.useEffect(function () {
        if (storeColumnsWidthVariant != columnLayout)
            handleSetColumnWidth(null);
    }, [columnLayout, storeColumnsWidthVariant, handleSetColumnWidth]);
    /**
     * base width of each displayed column and of all displayed columns put together
     */
    var displayColumnsWidth = React.useMemo(function () {
        var displayColumnsWidth = {};
        displayColumnsDefinitions.forEach(function (column) { return (displayColumnsWidth[column.name] = (storeColumnsWidth === null || storeColumnsWidth === void 0 ? void 0 : storeColumnsWidth[column.name]) || column.flexBasis); });
        return displayColumnsWidth;
    }, [displayColumnsDefinitions, storeColumnsWidth]);
    var totalColumnsWidth = React.useMemo(function () {
        return sum(Object.values(displayColumnsWidth));
    }, [displayColumnsWidth]);
    /**
     * handling of remaining space
     */
    // TODO optimize better
    var gridBoxRef = React.useRef(null);
    var testAdjustLastColumn = React.useCallback(function () {
        var _a;
        var _b;
        var gridWidth = ((_b = gridBoxRef === null || gridBoxRef === void 0 ? void 0 : gridBoxRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || null;
        if ((columnLayout == 'normal' || columnLayout == 'sticky') && gridWidth && totalColumnsWidth < gridWidth) {
            var lastColumn = displayColumnsDefinitions[displayColumnsDefinitions.length - 1];
            if (lastColumn) {
                var change = (_a = {}, _a[lastColumn.name] = displayColumnsWidth[lastColumn.name] + gridWidth - totalColumnsWidth, _a);
                handleSetColumnWidth(change);
            }
        }
    }, [columnLayout, displayColumnsDefinitions, displayColumnsWidth, gridBoxRef, handleSetColumnWidth, totalColumnsWidth]);
    React.useEffect(function () {
        testAdjustLastColumn();
    }, [testAdjustLastColumn]);
    React.useLayoutEffect(function () {
        window.addEventListener('resize', testAdjustLastColumn);
        return function () { return window.removeEventListener('resize', testAdjustLastColumn); };
    }, [testAdjustLastColumn]);
    /**
     * resizing of columns
     */
    var handleResizeDrag = React.useCallback(function (columnName, width) {
        var _a, _b;
        var _c;
        var i = displayColumnsDefinitions.findIndex(function (_a) {
            var name = _a.name;
            return name == columnName;
        });
        var nextColumn = displayColumnsDefinitions[i + 1];
        if (columnLayout == 'normal' || columnLayout == 'sticky') {
            var gridWidth = ((_c = gridBoxRef === null || gridBoxRef === void 0 ? void 0 : gridBoxRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) || null;
            var lastColumnWidth = displayColumnsWidth[displayColumnsDefinitions[displayColumnsDefinitions.length - 1].name];
            var lastColumnMinWidth = (gridWidth && gridWidth - (totalColumnsWidth - lastColumnWidth)) || 0;
            var minWidth = !nextColumn ? Math.max(lastColumnMinWidth, minColumnWidth) : minColumnWidth;
            var origin_1 = displayColumnsWidth[columnName];
            var newWidth = origin_1 + width < minWidth ? minWidth : origin_1 + width;
            handleSetColumnWidth((_a = {}, _a[columnName] = newWidth, _a));
        }
        else if (columnLayout == 'no-scroll') {
            var nextColumnWidth = displayColumnsWidth[nextColumn.name];
            var origin_2 = displayColumnsWidth[columnName];
            var addedColumnWidth = origin_2 + width < minColumnWidth ? minColumnWidth - origin_2 : width;
            var addedNextColumnWidth = nextColumnWidth - addedColumnWidth < minColumnWidth ? nextColumnWidth - minColumnWidth : addedColumnWidth;
            var addedWidth = Math.min(addedColumnWidth, addedNextColumnWidth);
            var columnsWidth = (_b = {}, _b[columnName] = origin_2 + addedWidth, _b);
            if (nextColumn) {
                columnsWidth[nextColumn.name] = nextColumnWidth - addedWidth;
            }
            handleSetColumnWidth(columnsWidth);
        }
    }, [displayColumnsDefinitions, columnLayout, displayColumnsWidth, totalColumnsWidth, minColumnWidth, handleSetColumnWidth]);
    return { totalColumnsWidth: totalColumnsWidth, gridBoxRef: gridBoxRef, displayColumnsWidth: displayColumnsWidth, handleResizeDrag: handleResizeDrag };
};
export default useColumnSizes;
